import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ICuocThaoLuanActionTypes } from "../../action-types/cuoc-thao-luan/ICuocThaoLuanActionTypes";
import { ICuocThaoLuanReducer } from "../../page-state-model/cuoc-thao-luan/ICuocThaoLuanReducer";
const iniState: ICuocThaoLuanReducer = {
    cuocThaoLuanComment: [],
    status: ePageBaseStatus.is_not_initialization,
    status_comment: ePageBaseStatus.is_not_initialization,
    status_reaction: ePageBaseStatus.is_not_initialization,
    reactions: []
}
export const cuocThaoLuanReducer = (state: ICuocThaoLuanReducer = iniState, action: ICuocThaoLuanActionTypes): ICuocThaoLuanReducer => {
    switch (action.type) {
        case "CUOC_THAO_LUAN_LOAD_INFO_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CUOC_THAO_LUAN_LOAD_INFO_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                cuocThaoLuan: action.payload
            }
        case "CUOC_THAO_LUAN_LOAD_INFO_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                cuocThaoLuan: undefined
            }
        case "CUOC_THAO_LUAN_LOAD_COMMENT_START":
            return {
                ...state,
                status_comment: ePageBaseStatus.is_loading
            }
        case "CUOC_THAO_LUAN_LOAD_COMMENT_SUCCESS":
            return {
                ...state,
                status_comment: ePageBaseStatus.is_completed,
                cuocThaoLuanComment: action.payload
            }
        case "CUOC_THAO_LUAN_LOAD_COMMENT_ERROR":
            return {
                ...state,
                status_comment: ePageBaseStatus.is_completed,
                cuocThaoLuanComment: []
            }
        case "CUOC_THAO_LUAN_ADD_COMMENT_START":
            return {
                ...state,
                status_comment: ePageBaseStatus.is_saving,
            }
        case "CUOC_THAO_LUAN_ADD_COMMENT_SUCCESS":
            return {
                ...state,
                status_comment: ePageBaseStatus.is_need_reload,
            }
        case "CUOC_THAO_LUAN_ADD_COMMENT_ERROR":
            return {
                ...state,
                status_comment: ePageBaseStatus.is_completed,
            }
        case "CUOC_THAO_LUAN_REMOVE_COMMENT_START":
            return {
                ...state,
                status_comment: ePageBaseStatus.is_saving,
            }
        case "CUOC_THAO_LUAN_REMOVE_COMMENT_SUCCESS":
            return {
                ...state,
                status_comment: ePageBaseStatus.is_need_reload,
            }
        case "CUOC_THAO_LUAN_REMOVE_COMMENT_ERROR":
            return {
                ...state,
                status_comment: ePageBaseStatus.is_completed,
            }
        case "CUOC_THAO_LUAN_LOAD_REACTION_START":
            return {
                ...state,
                status_reaction: ePageBaseStatus.is_loading,
            }
        case "CUOC_THAO_LUAN_LOAD_REACTION_SUCCESS":
            return {
                ...state,
                reactions: action.payload,
                status_reaction: ePageBaseStatus.is_need_reload,
            }
        case "CUOC_THAO_LUAN_LOAD_REACTION_ERROR":
            return {
                ...state,
                status_reaction: ePageBaseStatus.is_completed,
            }
        case "CUOC_THAO_LUAN_REMOVE_REACTION_START":
            return {
                ...state,
                status_reaction: ePageBaseStatus.is_loading,
            }
        case "CUOC_THAO_LUAN_REMOVE_REACTION_SUCCESS":
            return {
                ...state,
                status_reaction: ePageBaseStatus.is_need_reload,
            }
        case "CUOC_THAO_LUAN_REMOVE_REACTION_ERROR":
            return {
                ...state,
                status_reaction: ePageBaseStatus.is_completed,
            }

        default:
            return state;
    }
}